export const IAppUpdateScreenViewModelType = Symbol('IAppUpdateScreenViewModel');
